import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'

import { configureStore } from './middleware'
import ErrorBoundary from './components/ErrorBoundary'

import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'

import { App } from './App'
import registerServiceWorker from './registerServiceWorker';

// pull all the css in at the beginning
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import 'antd/dist/antd.css'
import './index.css'
import Auth from './Auth/Auth';

const initialState = {}
const history = createHistory()
const store = configureStore(initialState, history)

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#1890ff',
    },
    secondary: {
      main: '#f26430',
    },
  },
  typography: {
    useNextVariants: true,
  },

})

const auth = new Auth()

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ConnectedRouter history={history} >
        <MuiThemeProvider theme={theme}>
          <App auth={auth}/>
        </MuiThemeProvider>
      </ConnectedRouter>
    </Provider>
  </ErrorBoundary>
  , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js